
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cybercontact",
      function () {
        return require("private-next-pages/cybercontact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cybercontact"])
      });
    }
  